











































































import { POSPayment, POSPaymentMethod, POSTicketDetail } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Select from '@shared/components/forms/inputs/select/select.vue';
import moment from 'moment';

@Component({
  name: 'bpc-pos-payment-list',
  components: { 'bpc-select': Select },
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class PosPaymentList extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;
  @Prop({ type: Object, required: true }) readonly ticket: POSTicketDetail;
  @Prop({ type: Array, required: true }) readonly paymentMethodOptions: POSPaymentMethod[];
  @Prop({ type: Array, required: true }) readonly payments: POSPayment[];

  manualPaymentMethods = [
    'cash',
    'money_transfer',
    'manual_terminal',
    'cheque',
    'sport_cheque',
    'sodexo_cheque',
    'clearance',
    'direct_debit',
    'custom_1',
    'custom_2',
    'custom_3',
    'custom_4',
    'custom_5',
    'custom_6',
    'custom_7',
    'custom_8',
    'custom_9',
    'custom_10',
    'custom_11',
    'custom_12',
  ];

  get usedPaymentMethods(): string[] {
    return this.payments.map(payment => payment.payment_method_type);
  }

  // FIXME: This list should be done according to the payment channel
  getProvisionalPaymentMethods(payment: POSPayment) {
    return this.paymentMethodOptions?.filter(
      item =>
        this.manualPaymentMethods.includes(item.value) ||
        payment.payment_method_type === item.value,
    );
  }

  canBeModified(payment: POSPayment) {
    return this.manualPaymentMethods.includes(payment.payment_method_type);
  }

  async updatePaymentMethod(paymentId: number, paymentMethodType: string) {
    const response = await this.$posService.updatePaymentMethodType(
      this.posSessionId,
      this.ticket.id,
      paymentId,
      paymentMethodType,
    );
    if (response) {
      this.$emit('payment-method-type-updated', this.ticket);
      this.$bpcMessage.showSuccessMessage({
        text: 'global.success_original_payment_method_channel_message',
      });
    }
  }

  async refreshPayment(paymentId: number) {
    const ticketDetail = await this.$posService.updateTerminalPaymentStatus(
      this.posSessionId,
      this.ticket.id,
      paymentId,
    );
    this.$emit('ticket-detail-updated', ticketDetail);
  }

  async cancelNeptingPayment(paymentId: number) {
    const ticketDetail = await this.$posService.abortNeptingTerminal(
      this.posSessionId,
      this.ticket.id,
      paymentId,
    );
    this.$emit('ticket-detail-updated', ticketDetail);
  }

  /* Lifecycle hooks */
  // created() {}
  // updated() {}
  // destroyed() {}
}
